import { FC, useEffect, useMemo } from 'react';
import { Form } from '@repo-level/core-front';

import { FormGroup } from 'components/form/groups/FormGroup';
import { Input } from 'components/form/Input';
import { maskCardExpiryDate } from 'helpers/masks';
import {
  cardExpiryDate,
  cardExpiryDateValidator,
  composeValidators,
  required,
} from 'helpers/validators';
import { OfUnion } from 'types/common';
import { useFieldApi, useFieldState } from 'informed';

const validateCardExpiryDate = composeValidators(required, cardExpiryDate);

export const FieldCardExpiryDate: FC<
  OfUnion<Form.MethodField>[Form.MethodFieldType.CardExpiryDate]
> = ({ fieldName, label }) => {
  const fieldApi = useFieldApi(fieldName);
  const cardExpiryDate = useFieldState(fieldName);

  const error = useMemo(() => {
    if (!cardExpiryDate) return null;
    if (
      typeof cardExpiryDate.value === 'string' &&
      cardExpiryDate.value.length === 5
    ) {
      return cardExpiryDateValidator(cardExpiryDate.value, undefined);
    }
  }, [cardExpiryDate]);

  useEffect(() => {
    if (!error) return fieldApi.setError(undefined);
    fieldApi.setError(error);
  }, [error, fieldApi]);

  return (
    <FormGroup title={label || fieldName}>
      <Input
        field={fieldName}
        placeholder="MM/YY"
        validate={validateCardExpiryDate}
        formatter={maskCardExpiryDate}
      />
    </FormGroup>
  );
};
